import { ButtonHTMLAttributes, ReactNode } from 'react';

import { Styles, css, cx } from '@flipster/styled-system/css';
import { triggerChip } from '@flipster/styled-system/recipes';

import ChevronDownIcon from '../../../icon/generated/ChevronDownIcon';

interface TriggerChipBaseProps extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'type' | 'className' | 'children'
> {
  type?: 'rounded' | 'square';
  open?: boolean;
  icon?: ReactNode;
  label?: ReactNode;
  selected?: boolean;
  disabled?: boolean;
  css?: Styles;
}

interface TriggerChipPrimaryProps extends TriggerChipBaseProps {
  hierarchy?: 'primary';
  highlight?: 'on' | 'off';
}

interface TriggerChipSecondaryProps extends TriggerChipBaseProps {
  hierarchy: 'secondary';
  highlight?: never;
}

export type TriggerChipProps = TriggerChipPrimaryProps | TriggerChipSecondaryProps;

export const TriggerChip = ({
  type = 'rounded',
  hierarchy = 'primary',
  highlight = 'off',
  open,
  icon,
  label,
  selected,
  css: cssProps,
  ...buttonProps
}: TriggerChipProps) => {
  const classes = triggerChip({ type, hierarchy, highlight, selected: Boolean(selected) });

  return (
    <button type='button' className={cx('group', classes.container, css(cssProps))} {...buttonProps}>
      {icon && <div className={classes.icon}>{icon}</div>}
      {label && <div className={classes.label}>{label}</div>}
      <div aria-expanded={open} className={classes.chevron}>
        <ChevronDownIcon size={16} />
      </div>
    </button>
  );
};
TriggerChip.displayName = 'TriggerChip';
